<div matDialogTitle class="justify-between flex">
    <h1>
        {{ (material$ | async)?.DisplayName }} <span *ngIf="supplierId"> - {{ suppliersLabelsingular$ | async }}: {{ supplierName$ | async }}</span>
    </h1>
    <button app-round-button matTooltip="Materialzuordnung entfernen" [matDialogClose]="{remove: true}"><fa-icon icon="trash"></fa-icon></button>
</div>
<mat-dialog-content>
    <div class="flex justify-between px-4">
        <div class="py-4 text-center" *ngIf="supplierId">
            EK-Preis des {{ suppliersLabel$ | async }}:
            <br />
            <strong>{{ cost$ | async | currency }}</strong>
        </div>
        <div class="py-4 text-center" *ngIf="!supplierId">
            EK-Preis:
            <br />
            <strong>{{ costFromMaterial$ | async | currency }}</strong>
        </div>
        <div class="py-4 text-center" *ngIf="!supplierId">
            Standard Zuschlagssatz:
            <br />
            <strong>{{ defaultSurcharge$ | async | percent }}</strong>
        </div>
        <div class="py-4 text-center" *ngIf="supplierId">
            Errechnete Marge
            <br />
            <strong>{{ marge$ | async | percent }}</strong>
        </div>
        <div class="py-4 text-center" *ngIf="!supplierId">
            Errechnete Marge
            <br />
            <strong>{{ margeFromEntity$ | async | percent }}</strong>
        </div>
        <div class="py-4 text-center">
            VK-Preis:
            <br />
            <strong>{{ sellPrice$ | async | currency }}</strong>
        </div>
        <div class="py-4 text-center" *ngIf="supplierId">
            Listenpreis des {{ suppliersLabel$ | async }}:
            <br />
            <strong>{{ listPrice$ | async | currency }}</strong>
        </div>
    </div>
    <div class="px-2">
        <app-material-to-supplier-list-card
            class="px-2"
            style="display: block"
            [materialId]="materialId"
            [materialEKForm]="materialEKForm"
            *ngIf="showOtherSuppliersList"
            (M2SChange)="onSelectedPrice($event)"
            [showSupplierButton]="showSupplierButton"
            [showAcceptPriceButton]="showAcceptPriceButton"
        ></app-material-to-supplier-list-card>
        <app-material-ledger-import-list-card class="px-2" [title]="cardTitle$ | async" [ledgerImportDocumentType]="ledgerImportDocumentType" [materialId]="materialId" [supplierId]="supplierId"></app-material-ledger-import-list-card>
        <app-material-ledger-import-list-card
            *ngIf="showOtherDocumentType"
            class="px-2"
            [title]="otherCardTitle$ | async"
            [ledgerImportDocumentType]="ledgerImportOtherDocumentType"
            [materialId]="materialId"
            [supplierId]="supplierId"
        ></app-material-ledger-import-list-card>
    </div>
</mat-dialog-content>
